var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommunicationsNavIcon = function SvgCommunicationsNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#17172A",
    d: "M5.254 3.5h3.965V2.406c0-.355.273-.656.656-.656.355 0 .656.3.656.656V3.5h1.094c.957 0 1.75.793 1.75 1.75V7H2.41v7a.45.45 0 0 0 .438.438H8.89c.328.519.765.984 1.257 1.312H2.875c-.984 0-1.75-.766-1.75-1.75V5.25c0-.957.766-1.75 1.75-1.75h1.094V2.406c0-.355.273-.656.656-.656.355 0 .656.3.656.656zm3.719 8.313c0-2.16 1.777-3.938 3.964-3.938 2.16 0 3.938 1.777 3.938 3.938a3.94 3.94 0 0 1-3.937 3.937c-2.188 0-3.965-1.75-3.965-3.937m5.714.437a.45.45 0 0 0 .438-.437.47.47 0 0 0-.437-.438h-3.5a.45.45 0 0 0-.438.438c0 .246.191.437.438.437z"
  })));
};
export default SvgCommunicationsNavIcon;